import * as DeliveryManager from '../../SDK/DeliveryManager'
// import * as Util from '../../common/js/util'

const SHOW_MENU = true
const HIDE_MENU = false

const link = {
  state: {
    isShow: false,
    deliveryInfo: {
      access_mode: 4095,
      // code: '5130f383d90b460fbebc2a1eec9cd2a8',
      code: '',
      // counter_download: 0,
      // counter_preview: 0,
      // counter_upload: 0,
      ctime: '',
      expiration: -1,
      has_password: '',
      id: '',
      mime_type: '',
      mode: '',
      mtime: '',
      neid: '',
      nsid: '',
      password: '',
      path: '',
      type: '',
      url: ''
    }
  },
  getters: {
    getLinkIsShow: state => state.isShow,

    getDelivery: state => state.content
    // getDeliveryCode: state => state.deliveryInfo.code,
    // getDeliveryCtime: state => state.deliveryInfo.ctime,
    // getDeliveryExpiration: state => state.deliveryInfo.expiration,
    // getDeliveryHasPassword: state => state.deliveryInfo.has_password,
    // getDeliveryId: state => state.deliveryInfo.id,
    // getDeliveryMimeType: state => state.deliveryInfo.mime_type,
    // getDeliveryMode: state => state.deliveryInfo.mode,
    // getDeliveryMtime: state => state.deliveryInfo.mtime,
    // getDeliveryNeid: state => state.deliveryInfo.neid,
    // getDeliveryNsid: state => state.deliveryInfo.nsid,
    // getDeliveryPassword: state => state.deliveryInfo.password,
    // getDeliveryPath: state => state.deliveryInfo.path,
    // getDeliveryType: state => state.deliveryInfo.type,
    // getDeliveryUrl: state => state.deliveryInfo.url
  },
  mutations: {
    showLink (state, obj) {
      state.isShow = SHOW_MENU
    },
    hideLink (state) {
      state.isShow = HIDE_MENU
    },
    showDeliveryConfirmTips (state, obj) {
      state.deliveryconfirmTipsIsShow = true
    },
    hideDeliveryConfirmTips (state, obj) {
      state.deliveryconfirmTipsIsShow = false
    },
    //   let contents = obj
    //   for (let i = 0; i < contents.length; i++) {
    //     let file = {}
    //     let item = contents[i]
    //     let d = Util.resolvePath(item.path, item.is_dir)
    //     file.access_mode = item.access_mode
    //     file.code = item.code
    //     file.counter_download = item.counter_download
    //     file.counter_preview = item.counter_preview
    //     file.counter_upload = item.counter_upload
    //     file.ctime = item.ctime
    //     file.description = item.description
    //     file.expiration = item.expiration
    //     file.has_password = item.has_password
    //     file.id = item.id
    //     file.mime_type = item.mime_type
    //     file.mode = item.mode
    //     file.cssAction = Util.getCSSActionByCode(item.mode).authCSS
    //     file.mtime = Util.formatDate(item.mtime, 'yyyy-MM-dd' + ' hh:mm')
    //     file.neid = item.neid
    //     file.nsid = item.nsid
    //     file.password = item.password
    //     file.path = item.path
    //     file.type = d.is_dir
    //     file.url = item.url
    //     state.content.push(file)
    //   }
    //   // state.content = files
    // },
    // setAuth (state, obj) {
    //   state.upload = Util.getPrivatePrivilege(state.content.cssAction || state.content.action).canUpload
    //   state.download = Util.getPrivatePrivilege(state.content.cssAction || state.content.action).canDownload
    //   state.preview = Util.getPrivatePrivilege(state.content.cssAction || state.content.action).canPreview
    // },
    getDeliveryInfo (state, obj) {
    },
    cancelDeliveryInfo (state, obj) {
    }
  },
  actions: {
    showLinkInfo ({commit}, obj) {
      commit('showLink', obj)
    },
    hideLinkInfo ({commit}) {
      commit('hideLink')
    },
    createDelivery ({commit}, obj) {
      DeliveryManager.create(obj.param)
        .then(response => {
          console.log('创建数据' + response)
        })
    },
    getDelivery ({commit}, obj) {
      DeliveryManager.getDeliveryInfo(obj.param)
        .then(response => {
          console.log(response)
        })
    },
    cancelDelivery ({commit}, obj) {
      DeliveryManager.delDelivery(obj.params).then(response => {
        console.log(response)
        if (response === '') {
          commit('setToast', {isShow: true, message: '取消成功', iconClass: 'icon-success'})
          commit('setIsReloadFilelist', true)
          // commit('setCurrentPathType')
        }
      }, err => {
        commit('setToast', {isShow: true, message: '取消失败', iconClass: 'icon-error'})
        console.log(err)
      })
    }
  }
}
export default link



// WEBPACK FOOTER //
// ./src/store/modules/delivery.js